import Component from 'flarum/common/Component';
import Alert from 'flarum/common/components/Alert';

/**
 * Rough check for "does this look like the admin wrote HTML?".
 * Matches an opening tag such as `<b`, `<a href=...` or `<br />`.
 */
const LOOKS_LIKE_HTML = /<[a-z][a-z0-9]*(\s[^<>]*)?\/?>/i;

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Renders the configurable notice shown above the log in modal's input fields.
 *
 * Plain text is escaped and its line breaks are turned into `<br>`, so an admin
 * can simply type multiple lines into the setting's textarea. As soon as the
 * message contains markup it is rendered verbatim instead, which allows links,
 * lists and other formatting.
 *
 * The `variant` attr selects the presentation: `plain` (default) keeps the
 * unobtrusive muted text, anything else wraps it in a Flarum `Alert` box.
 */
export default class LoginMessage extends Component {
  view() {
    const message = String(this.attrs.message ?? '');
    const variant = this.attrs.variant || 'plain';

    const html = LOOKS_LIKE_HTML.test(message) ? message : escapeHtml(message).replace(/\r\n|\r|\n/g, '<br>');

    const body = m.trust(html);

    if (variant === 'plain') {
      return <div className="Form-group StatikAppLoginMessage StatikAppLoginMessage--plain">{body}</div>;
    }

    return (
      <div className="Form-group StatikAppLoginMessage StatikAppLoginMessage--boxed">
        <Alert type={variant} dismissible={false}>
          {body}
        </Alert>
      </div>
    );
  }
}
